var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojibutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "219.000000pt",
    height: "190.000000pt",
    viewBox: "0 0 219.000000 190.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,190.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M938 1780 c-275 -47 -521 -243 -624 -498 -46 -116 -58 -180 -58 -317 0 -104 4 -145 22 -208 83 -292 307 -512 597 -588 111 -29 289 -29 400 0 358 94 600 396 621 775 6 104 5 113 -16 139 -28 35 -77 37 -107 5 -17 -19 -21 -41 -26 -135 -9 -183 -71 -332 -187 -451 -209 -215 -518 -269 -785 -137 -241 119 -388 371 -372 640 21 365 313 634 690 635 74 0 90 3 107 20 30 30 27 83 -6 109 -23 18 -40 21 -118 20 -50 -1 -112 -5 -138 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564 1778 c-33 -15 -44 -51 -44 -138 l0 -80 -88 0 c-80 0 -91 -2 -110 -23 -27 -29 -28 -67 -3 -98 17 -21 29 -24 109 -27 l90 -4 4 -90 c3 -80 6 -92 27 -109 32 -26 73 -24 99 4 19 20 22 35 22 110 l0 87 80 0 c89 0 123 11 139 47 16 34 14 47 -10 77 -19 25 -25 26 -115 26 l-94 0 0 94 c0 90 -1 96 -26 115 -29 23 -48 25 -80 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802 1244 c-33 -23 -31 -86 4 -113 15 -12 34 -21 44 -21 34 0 70 39 70 76 0 63 -65 95 -118 58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249 1242 c-33 -27 -30 -78 5 -109 33 -28 56 -29 90 -2 19 15 26 30 26 55 0 65 -69 97 -121 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 865 c-37 -37 -32 -68 21 -125 187 -200 477 -198 663 4 37 42 42 52 37 79 -7 38 -39 67 -72 67 -14 0 -45 -19 -79 -50 -75 -68 -126 -92 -207 -98 -59 -4 -74 -1 -130 26 -35 16 -84 51 -110 76 -55 53 -86 59 -123 21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojibutton);
export default __webpack_public_path__ + "static/media/emojibutton.b9a62ede55f7b206a7a791d97a581fd3.svg";
export { ForwardRef as ReactComponent };